import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchGalleryPhotos } from "../../services/mediaApi";
import { optimizeCloudinaryUrl } from "../../utils/cloudinaryUrl";
import "./SocialHub.css";

const SocialHub = () => {
  const navigate = useNavigate();

  const [allPhotos, setAllPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "https://placehold.co/300x300?text=No+Image";
    return optimizeCloudinaryUrl(imagePath, 800);
  };

  // Fetch photos on mount
  useEffect(() => {
    let isMounted = true;
    
    const fetchPhotos = async () => {
      try {
        setLoading(true);
        const { images } = await fetchGalleryPhotos();
        if (!isMounted) return;

        if (images && images.length > 0) {
          setAllPhotos(images.slice(0, 4));
          setError(null);
        } else {
          setError("No gallery images found.");
        }
      } catch (error) {
        if (isMounted) {
          setError(error.message || "Failed to load gallery images.");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchPhotos();
    return () => { isMounted = false; };
  }, []);

  return (
    <section id="social-hub" className="social-hub">
      <div className="container">
        <h1 className="heading-unified">Social Hub</h1>
        
        <div className="preview-images">
          {loading ? (
            <div className="loading-state">Loading gallery...</div>
          ) : error ? (
            <div className="error-state">
              <p>{error}</p>
              <small>Please check your Cloudinary credentials in .env and restart backend.</small>
            </div>
          ) : allPhotos.length > 0 ? (
            allPhotos.map((photo, index) => (
              <motion.div 
                key={photo._id || photo.id || `photo-${index}`} 
                className="social-hub-card"
                initial={{ opacity: 1, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <img
                  src={getImageUrl(photo.imageUrl || photo.url)}
                  alt={photo.title || "Cloudinary Image"}
                  className="social-hub-img"
                  width="300"
                  height="300"
                  loading="eager"
                  onError={(e) => {
                    if (!e.target.src.includes('unsplash.com')) {
                      e.target.src = "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=300&h=300&auto=format&fit=crop";
                      console.warn("Gallery image failed to load, using fallback");
                    }
                  }}
                />
                {photo.title && (
                  <div className="img-overlay">
                    <span className="photo-title">{photo.title}</span>
                  </div>
                )}
              </motion.div>
            ))
          ) : (
            <div className="empty-gallery">No images found in Cloudinary.</div>
          )}
        </div>

        <div className="see-more-container">
          <button
            className="see-more-btn"
            onClick={() => navigate("/photos")}
          >
            Explore Gallery
          </button>
        </div>
      </div>
    </section>
  );
};

export default SocialHub;